























import { Component, Vue } from "vue-property-decorator";
import LeftBar from "@/components/LeftBar.vue";
import EventPost from "@/components/EventPost.vue";
import { SiteEvent } from "@/components/data-types/SiteEvent";

@Component({
  components: {
    LeftBar,
    EventPost
  }
})
export default class Events extends Vue {
  events = [];
  created() {
    fetch("/json-data/event-list.json")
      .then(r => r.json())
      .then(events => {
        this.events = events
          .filter((event: SiteEvent) => {
            const now = new Date();
            const start = new Date(event.start);
            const end = new Date(event.end);
            //invalid start time
            if (isNaN(start.getTime())) return;
            //remove past events
            if (now >= start && now >= end) return;
            return event;
          })
          .sort((event1: SiteEvent, event2: SiteEvent) => {
            const start1 = new Date(event1.start);
            const start2 = new Date(event2.start);
            const end1 = new Date(event1.end);
            const end2 = new Date(event2.end);
            //same start time, display event ending soonest first
            if (start1.getTime() === start2.getTime()) {
              //Return equal
              if (end1.getTime() === end2.getTime()) return 0;
              //event 1 comes first
              if (end1 > end2) return 1;
              //event 2 comes first
              return -1;
            }
            if (start1 > start2) return 1;
            return -1;
          });
      });
  }
}
